
export enum EnumTipoPeaje {
	Peaje_1_1 = 1,
	Peaje_1_2 = 2,
	Peaje_1_3 = 3,
	Peaje_2_1 = 4,
	Peaje_2_2 = 5,
	Peaje_2_3 = 6,
	Peaje_2_4 = 7,
	Peaje_2_5 = 8,
	Peaje_2_6 = 9,
	Peaje_3_1 = 16,
	Peaje_3_2 = 17,
	Peaje_3_3 = 18,
	Peaje_3_4 = 19,
	Peaje_3_5 = 20,
	Peaje_41 = 21,
	Peaje_42 = 22,
	Peaje_43 = 23,
	Peaje_44 = 24,
	Peaje_45 = 25,
	Peaje_46 = 26,
	Peaje_47 = 27,
	Peaje_A1 = 28,
	Peaje_A2 = 29,
	Peaje_A3 = 30,
	Peaje_B1 = 31,
	Peaje_B2 = 32,
	Peaje_C1 = 33,
	Peaje_C2 = 34,
	Peaje_D1 = 35,
	Peaje_D2 = 36,
	Peaje_M1 = 37,
	Peaje_M2 = 38,
	Peaje_99 = 39,
	Peaje_BPgt1 = 40,
	Peaje_BPgt2 = 41,
	Peaje_BPC1 = 42,
	Peaje_BPC2 = 43,
	Peaje_BPL1 = 44,
	Peaje_BPL2 = 45,
	Peaje_MP1 = 46,
	Peaje_MP2 = 47,
	Peaje_MPC1 = 48,
	Peaje_MPC2 = 49,
	Peaje_MPL1 = 50,
	Peaje_MPL2 = 51,
	Peaje_BPFXM = 52,
	Peaje_BPFXAM = 53,
	Peaje_MPFXM = 54,
	Peaje_MPFXAM = 55,
	Peaje_BPlt1 = 56,
	Peaje_BPlt2 = 57,
	Peaje_BPlt3 = 58,
	Peaje_BPlt4 = 59,
	Peaje_20A = 60,
	Peaje_20DHA = 61,
	Peaje_20DHS = 62,
	Peaje_21A = 63,
	Peaje_21DHA = 64,
	Peaje_21DHS = 65,
	Peaje_30A = 66,
	Peaje_31A = 67,
	Peaje_61A = 68,
	Peaje_61B = 69,
	Peaje_62 = 70,
	Peaje_63 = 71,
	Peaje_64 = 72,
	Peaje_65 = 73,
	Peaje_BPS1 = 74,
	Peaje_BPS2 = 75,
	Peaje_20TD = 76,
	Peaje_30TD = 77,
	Peaje_61TD = 78,
	Peaje_62TD = 79,
	Peaje_63TD = 80,
	Peaje_64TD = 81,
	Peaje_30TDVE = 82,
	Peaje_61TDVE = 83,
	Peaje_R1 = 100,
	Peaje_R2 = 101,
	Peaje_R3 = 102,
	Peaje_R4 = 103,
	Peaje_B5 = 104,
	Peaje_A5 = 105,
	Peaje_B6 = 106,
	Peaje_A6 = 107,
	Peaje_B7 = 108,
	Peaje_A7 = 109,
	Peaje_R8 = 110,
	Peaje_R9 = 111,
	Peaje_R10 = 112,
	Peaje_R11 = 113,
	Peaje_S1 = 114,
	Peaje_S2 = 115,
	Peaje_S3 = 116,
	Peaje_S4 = 117,
	Peaje_S5 = 118,
	Peaje_S6 = 119,
	Peaje_S7 = 120,
	Peaje_S8 = 121,
	Peaje_S9 = 122,
	Peaje_S10 = 123,
	Peaje_S11 = 124,
	Peaje_R5 = 125,
	Peaje_R6 = 126,
	Peaje_R7 = 127
}